import {
    client as BraintreeClient,
    hostedFields
} from 'braintree-web';
import Router from './createRouter';
import ROUTES from './constants';
import {
    templateModal,
    templateRenderer,
    clearPopup,
    showPopup,
    activateContinue,
    modalWindow,
    trialInfo
} from '../utils';
import jwtDecode from 'jwt-decode';
import authService from '../auth';
import billingSDK from '../billing';
import { CLIENT_AUTHORIZATION } from '../constants/payment';

const popupFailedModal = templateModal('popup_card_error');
const failedModal = () => {
    modalWindow(popupFailedModal).show();
};

const popupCvv = templateModal('popup_cvv');
const cvvModal = () => {
    modalWindow(popupCvv).show();
};

let prodprice = null;

export default path => {
    const billingFormTemplate = templateRenderer('payment-card');

    return {
        [`${path}/:id`]: {
            uses: params => {
                Router.updatePageLinks();
                const { id } = params;
                showPopup();
                billingSDK.getPaymentPlans()
                    .then(response => {
                        if (response.message) {
                            clearPopup();
                            Router.navigate(ROUTES.SIGNIN);
                        } else {
                            const { data } = response;
                            const { plans } = data;
                            const plan = plans.find(plan => plan.id === id);
                            prodprice = plan.price;
                            trialInfo(plan.trialDuration, plan.price);
                        }
                    });
                // eslint-disable-next-line handle-callback-err
                const createHostedFields = (err, client) => {
                    hostedFields.create({
                        client: client,
                        id: 'cardForm',
                        styles: {
                            input: {
                                'font-size': '16px',
                                color: '#fff',
                                'font-family': 'Red Hat Display, sans-serif',
                                'font-weight': '500'
                            },
                            'input:-webkit-autofill': {
                                transition: 'all ease 3600s'
                            },
                            'input:-webkit-autofill:hover': {
                                transition: 'all ease 3600s'
                            },
                            'input:-webkit-autofill:focus': {
                                transition: 'all ease 3600s'
                            },
                            'input:-webkit-autofill:active': {
                                transition: 'all ease 3600s'
                            },
                            '.invalid': {
                                color: '#F63566 !important'
                            }
                        },
                        fields: {
                            number: {
                                selector: '#payment_form_card_number',
                                placeholder: 'Card Number'
                            },
                            cardholderName: {
                                selector: '#payment_form_cardholder_name',
                                placeholder: 'Name on card'
                            },
                            expirationMonth: {
                                selector: '#payment_form_expiration_month',
                                placeholder: 'MM'
                            },
                            expirationYear: {
                                selector: '#payment_form_expiration_year',
                                placeholder: 'YY'
                            },
                            cvv: {
                                selector: '#payment_form_cvv',
                                placeholder: 'CVV',
                                type: 'password'
                            }
                        }
                    },
                    (err, hostedFields) => { // eslint-disable-line handle-callback-err
                        const submitBtn = document.getElementById('submit-btn');
                        submitBtn.addEventListener('click', submitHandler.bind(null, hostedFields));
                        activateContinue(hostedFields);
                        clearPopup();
                    });
                };
                const submitHandler = (hostedFields, event) => {
                    event.preventDefault();
                    showPopup();
                    const submitBtn = document.getElementById('submit-btn');
                    hostedFields.tokenize((error, payload) => {
                        if (error) {
                            submitBtn.removeAttribute('disabled');
                            clearPopup();
                            failedModal();
                            gtag('event', 'Card payment error'); // eslint-disable-line no-undef
                            gtag('event', 'Card credits failed'); // eslint-disable-line no-undef
                        } else {
                            var form = document.getElementById('cardForm');
                            form.payment_method_nonce.value = payload.nonce;
                            billingSDK.paymentCheckout({
                                nonce: payload.nonce,
                                planId: id
                            }).then((response) => {
                                const { error } = response;
                                if (error) {
                                    gtag('event', 'Card payment error'); // eslint-disable-line no-undef
                                    gtag('event', 'Card credits failed'); // eslint-disable-line no-undef
                                    clearPopup();
                                    failedModal();
                                } else {
                                    const user = authService.getUser(jwtDecode);
                                    // eslint-disable-next-line camelcase
                                    const { plan_id, subscription_id } = response.data;
                                    // eslint-disable-next-line no-undef
                                    gtag('event', 'checkout_completed',
                                        {
                                            eventCategory: 'purchases',
                                            eventLabel: plan_id,
                                            SubscriptionID: subscription_id,
                                            UserID: user.id,
                                            PaymentMethod: 'Hosted Fields',
                                            ProductID: plan_id,
                                            ProductPrice: prodprice,
                                            Source: 'Regular'
                                        });
                                    clearPopup();
                                    Router.navigate(ROUTES.CONGRATS);
                                }
                            });
                        }
                    });
                };
                if (params) {
                    BraintreeClient.create(
                        {
                            authorization: CLIENT_AUTHORIZATION
                        },
                        createHostedFields
                    );
                }
                document.querySelector('.cvv-after').addEventListener('click', cvvModal);
            },
            hooks: {
                before: (done) => {
                    billingFormTemplate.mount();
                    done();
                },
                leave: _ => {
                    billingFormTemplate.unmount();
                }
            }
        },
        [`${path}`]: {
            uses: _ => {
                Router.navigate(ROUTES.PRICES);
            }
        }
    };
};
